import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { InvoicesService } from '../../../services/invoices.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { BillingPortalProps } from '../../../models/BillingPortalProps';
import { SessionStorageService } from '../../../services/session-storage.service';
import { BansStorageService } from '../../../services/bans-storage.service';
import { PaymentMethod } from '../../../models/payment/payment-methods/PaymentMethod';
import { PaymentMethodService } from '../../../services/payment-method.service';
import { ReusableErrorComponent } from '../../popup/reusable-error-component/reusable-error.component';
import { paymentProcessService } from '../../../services/payment-process.service';
import { MobileDeviceService } from '../../../services/mobile-view-checker.service';

@Component({
  selector: 'app-manage-payment-methods',
  templateUrl: './manage-payment-methods.component.html',
  styleUrls: ['./manage-payment-methods.component.css']
})

export class ManagePaymentMethodsComponent {

  @Output() paymentMethod = new EventEmitter<any>();
  @ViewChild(ReusableErrorComponent) errorPopup!: ReusableErrorComponent;

  invoiceList: Array<any> = new Array();
  amount: any = 0;
  paymentMethodsList: PaymentMethod[] = [];
  deleteConfimation: boolean = false;
  selectedPM: any = '';
  recurringPaymentMethodId?: string;
  defaultPaymentMethodId?: string;
  warningText: boolean = false;
  paymentsFormVisibility: boolean = false;
  selectedPMForEdit: any = {};
  selectedPMForPayment: any = {};
  pmListApiLoader: boolean = true;
  infoPopupVisible: boolean = false;
  popupErrorMessage: string = "";
  inPaymentFlowPage: boolean = false;
  banCAs = new Map<string, Array<string>>();
  ban: string = history.state.ban;
  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  customerIDs: Array<string> = [];
  banResponse: any;
  isPaymentMethodsAPICall: boolean = false;
  disableAddPaymentMethod: boolean = false;
  errorPopupInstruction: string = '';
  isMobileView: boolean = false;

  constructor(
    private router: Router,
    private invoicesService: InvoicesService,
    private modalService: NgbModal,
    private storageService: SessionStorageService,
    private bansService: BansStorageService,
    private paymentMethodsService: PaymentMethodService,
    private paymentProcessService: paymentProcessService,
    private MobileDeviceService: MobileDeviceService
  ) {
    if (this.router.url != '/invoices/setting/autopay' && this.router.url != '/invoices/setting/paymentMethods') {
      let historicalInvoicePymtIndicator = this.router.url.includes("/historical-data")
      var List = JSON.parse(localStorage.getItem("InvoiceList") || "[]");
      this.ban = List[0] && List[0].bpNo;
      if (!this.ban && !!localStorage.getItem("ban"))
        this.ban = localStorage.getItem("ban") || ""
      if (List && Array.isArray(List) && !historicalInvoicePymtIndicator) {
        // Normal Invoice Payment
        List.forEach((element: any) => {
          this.invoiceList.push(element);
          this.amount = this.amount + parseFloat(parseFloat(element.editedAmountToPay).toFixed(2));
        });
        localStorage.setItem("totalAmountToPay", this.amount);
      } else if (historicalInvoicePymtIndicator) {
        // Historical Invoice Payment
        let amt = localStorage.getItem("totalAmountToPay") || "0"
        this.amount = parseFloat(parseFloat(amt).toFixed(2))
      }
      this.getListOfPayments()
    }
    else {
      this.getCustomerIds();
    }
  }

  ngOnInit() {
    if (this.router.url.includes("checkout")) {
      this.inPaymentFlowPage = true;
    }
    this.MobileDeviceService.isMobileView$.subscribe((isMobile) => {
      this.isMobileView = isMobile;
    });
  }

  get showContinueTopButton() {
    return (this.inPaymentFlowPage && !this.pmListApiLoader && this.paymentMethodsList.length && this.paymentMethodsList.length > 4)
  }

  getListOfPayments() {
    this.pmListApiLoader = true;
    this.paymentsFormVisibility = false;
    this.selectedPMForEdit = {}
    this.ban = this.ban ? this.ban : JSON.parse(JSON.stringify(localStorage.getItem('Selected_BAN_Dropdown_Value')));
    this.invoicesService.getPaymentMethods(this.ban)
      .pipe(
        catchError((error) => {
          this.pmListApiLoader = false;
          this.paymentMethodsList = [];
          console.log(error);
          return of(null);
        })
      ).subscribe((res) => {
        if (res) {
          this.paymentMethodsList = res.paymentMethods || [];
          if (this.paymentMethodsList.length == 1) {
            this.selectPMForPayment(this.paymentMethodsList[0])
          }
          /*
          this.defaultPaymentMethodId = res.defaultPaymentMethodId
          let defaultPaymentMethod = this.paymentMethodsList.find(pm => pm.id == res.defaultPaymentMethodId)
          this.selectedPMForPayment = defaultPaymentMethod
          */
          this.getRecurringPaymentId()
        } else {
          this.pmListApiLoader = false;
          console.error('An error occurred while fetching payment methods.');
        }
      });
  }


  maskBAID(baid: string) {
    // Check if the string is valid
    if (!baid || typeof baid !== 'string') {
      return '';
    }
    // Extract the last four characters
    const lastFourChars = baid.slice(-4);
    // Create the masked string with * characters in the middle
    const maskedString = baid[0] + '*'.repeat(baid.length - 7) + lastFourChars;
    return maskedString;
  }

  getRecurringPaymentId() {
    if (this.ban && this.ban != "BAN") {
      console.log("fetching autopay " + environment.serverURL + environment.pgURI + 'mm-payment/schedule/' + this.ban)
      this.pmListApiLoader = true;
      this.paymentMethodsService.getRecurring(this.ban)
        .pipe(
          catchError((err) => {
            console.log("Error getting recurring payment setting")
            console.log(err)
            this.pmListApiLoader = false;
            this.openConfirmation("Could not fetch recurring payment setting.")
            return of();
          })
        ).subscribe((setting) => {
          console.log(setting)
          this.pmListApiLoader = false;
          let isRecurringEnabled = setting?.status?.toUpperCase() == "ACTIVE"
          if (isRecurringEnabled)
            this.recurringPaymentMethodId = setting?.paymentMethodId
          else this.recurringPaymentMethodId = ""

        })
    }
  }


  toggleRecurringPayment(e: any, pm: any, isRemove?: boolean) {
    e.stopPropagation()
    if (this.isCardExpired(pm) && !isRemove) {
      this.errorPopupInstruction = "The payment method is expired. Please choose a different payment method"
      this.errorPopup.showPopup();
      return;
    }
    this.pmListApiLoader = true;
    var keyname = JSON.parse(localStorage.getItem("msal.account.keys") || '[]');
    var clientInfo = JSON.parse(localStorage.getItem(keyname[0]) || '');
    let userEmail = clientInfo && clientInfo.idTokenClaims && clientInfo.idTokenClaims.emails && clientInfo.idTokenClaims.emails[0];
    // let userEmail = "test@user.com";
    let walletId = pm.id
    let pmInfo = {
      "paymentAuthId": walletId,
      "creditAccount": this.ban,
      "emailAddress": userEmail,
      "paymentChannelKind": "Web",
      "debitName": "",
      "paymentType": pm.paymentType
    }
    if (isRemove) {
      this.paymentMethodsService.unSetRecurring(this.ban, userEmail)
        .pipe(
          catchError((error) => {
            this.pmListApiLoader = false;
            this.openConfirmation(error)
            return of();
          })
        ).subscribe((_) => {
          this.warningText = false;
          this.recurringPaymentMethodId = "";
          this.pmListApiLoader = false;
        });
    } else {
      this.paymentMethodsService.setRecurring(pmInfo, this.recurringPaymentMethodId)
        .pipe(
          catchError((error) => {
            this.pmListApiLoader = false;
            this.openConfirmation(error)
            return of();
          })
        ).subscribe((res) => {
          this.warningText = false;
          this.recurringPaymentMethodId = res.paymentMethodId?.toUpperCase() || pm.id.toUpperCase();
          this.pmListApiLoader = false;
        });
    }
  }

  setDefaultPaymentMethod(e: any, paymentMethod: any) {
    e.stopPropagation()
    this.pmListApiLoader = true;
    this.paymentMethodsService.setDefaultPaymentMethod(paymentMethod.paymentType, this.ban, paymentMethod.id)
      .pipe(
        catchError((error) => {
          this.openConfirmation(error)
          return of();
        })
      ).subscribe((_: any) => {
        this.pmListApiLoader = false;
        this.defaultPaymentMethodId = paymentMethod.id;
      });
  }

  deletePaymentMethod(e: any, pm: any) {
    e.stopPropagation()
    document.body.style.overflow = 'auto';
    this.deleteConfimation = false;
    this.selectedPM = '';
    this.paymentMethodsService.deletePaymentMethod(this.ban, pm.id)
      .pipe(
        catchError((error) => {
          this.openConfirmation(error)
          return of(null);
        })
      ).subscribe((res: any) => {
        this.openConfirmation("Payment Method Deleted Successfully..!")
        this.warningText = false;
        this.getListOfPayments()
      });
  }

  addPaymentMethod() {
    if (this.disableAddPaymentMethod) {
      return
    }
    document.body.style.overflow = 'hidden';
    this.paymentsFormVisibility = true;
  }

  isCardExpired(paymentMethod:any) {
    let currMonth = new Date().getMonth() + 1
    let currYear = new Date().getFullYear() % 100
    let { expirationMonth, expirationYear } = paymentMethod
    let isExpired = paymentMethod?.paymentType?.toLowerCase?.().includes("card") &&
      currYear > parseInt(expirationYear) && currMonth > parseInt(expirationMonth)
    return isExpired
  }

  selectPMForPayment(paymentMethod: any) {    
    if (this.isCardExpired(paymentMethod)) {
      this.errorPopupInstruction = "The payment method is expired. Please choose a different payment method"
      this.errorPopup.showPopup();
      return;
    }
    this.selectedPMForPayment = paymentMethod
  }

  continueBtnClick() {
    if (this.selectedPMForPayment.type == 'MoneyMarket') {
      this.errorPopupInstruction = "The selected MoneyMarket payment method is not supported for payments. Please add or select another payment method.";
      this.errorPopup.showPopup();
      return;
    }
    this.paymentProcessService.setSelectedPaymentMethod(this.selectedPMForPayment)
    var invoicesData = {
      totalAmounttoPay: this.amount,
      invoices: this.invoiceList,
      ban: this.ban,
    };
    console.log("Final invoice data", {
      totalAmounttoPay: this.amount,
      invoices: this.invoiceList,
      ban: this.ban,
    })
    localStorage.setItem("InvoiceList", JSON.stringify(invoicesData));
    this.paymentMethod.emit(this.selectedPMForPayment)
  }

  editPaymentMethod(e: any, paymentMethodDetails: any) {
    e.stopPropagation()
    this.selectedPMForEdit = paymentMethodDetails;
    document.body.style.overflow = 'auto';
    this.paymentsFormVisibility = true;
  }

  openDeleteModal(e: any, id: any) {
    e.stopPropagation()
    document.body.style.overflow = 'hidden';
    if (id.toUpperCase?.() == this.recurringPaymentMethodId?.toUpperCase()) {
      this.warningText = true
    }
    this.selectedPM = id;
    this.deleteConfimation = true;
  }

  closeDeleteModal(e: any) {
    e.stopPropagation()
    document.body.style.overflow = 'auto';
    this.warningText = false;
    this.deleteConfimation = false
  }

  closePopup() {
    document.body.style.overflow = 'auto';
    this.paymentsFormVisibility = false;
    this.selectedPMForEdit = {}
    this.infoPopupVisible = false;
    this.popupErrorMessage = '';
  }

  openConfirmation(text: string,) {
    document.body.style.overflow = 'hidden';
    this.infoPopupVisible = true;
    this.popupErrorMessage = text;
  }

  get isSettingsPage() {
    return (this.router.url == '/invoices/setting/autopay' || this.router.url == '/invoices/setting/paymentMethods');
  }

  // ngAfterViewInit() {
  //   if (this.isSettingsPage) {
  //     this.getCustomerIds();
  //   }
  // }

  async getCustomerIds(): Promise<void> {
    this.getBans();
  }

  getBans() {
    this.bansService.bans.subscribe((bans: any) => {
      this.bansService.bansApiResponse.subscribe((bansResponse: any) => {
        if (bansResponse) {
          this.banResponse = bansResponse;
        }
      })
      if (bans) {
        this.banCAs = bans;
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];
        this.disableAddPaymentMethod = false;
        this.getListOfPayments();
      }
      else {
        this.bansService.banFlag.subscribe(
          (isPresent: boolean) => {
            if (!isPresent) {
              this.pmListApiLoader = false;
              this.disableAddPaymentMethod = true;
            }
          }
        );
      }
    })
  }

  selectBan(selectedBan: any): void {
    this.ban = selectedBan;
    if (this.ban != "BAN") {
      this.getListOfPayments();
    }
  }

  formatCardType(input: any) {
    return input
      .replace(/([a-z])([A-Z])/g, '$1 $2')
  }

  formatPaymentData(input: any) {
    const formattedInput = input.slice(-4);
    return '**** ' + formattedInput;
  }

}
